/*
 * @Author: Json Chen
 * @Date: 2021-07-09 11:16:41
 * @LastEditTime: 2022-06-01 17:26:33
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Logistics/PickupLocations/index.tsx
 */

// import CommonHeader from '@/src/components/CommonHeader';
import { Button, SizeFittingTable } from '@/src/components/Antd';
import {
  getPickupLocations,
  setPickupLocationActivate,
  setPickupLocationDeactivate,
} from '@/src/request/settings/logistics/pickupLocation';
import {
  isUserValid,
  storeResourceNameGenerator,
} from '@/src/tools/getUserInfo';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from '@/src/types/common/resources';
import { useRequest } from 'ahooks';
import { Modal, Spin } from 'antd';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useHistory } from 'react-router';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import styles from '../style.module.less';
import { getAreaCodes } from 'src/constrains/GlobalProvider/slice';
import { useSelector } from 'react-redux';
import { get } from 'lodash';

const permissions = () => {
  const add_edit_click_and_collect_pickup_location = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsLogisticsPickupLocations,
        operation: EnumOperation.add_edit_click_and_collect_pickup_location,
      }),
    ],
  });
  const delete_click_and_collect_pickup_location = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsLogisticsPickupLocations,
        operation: EnumOperation.delete_click_and_collect_pickup_location,
      }),
    ],
  });
  //view_click_and_collect_pickup_location_details
  const view_click_and_collect_pickup_location_details = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsLogisticsPickupLocations,
        operation: EnumOperation.view_click_and_collect_pickup_location_details,
      }),
    ],
  });
  return {
    add_edit_click_and_collect_pickup_location,
    delete_click_and_collect_pickup_location,
    view_click_and_collect_pickup_location_details,
  };
};

const PickupLocations = () => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    add_edit_click_and_collect_pickup_location,
    delete_click_and_collect_pickup_location,
    view_click_and_collect_pickup_location_details,
  } = permissions();
  const history = useHistory();
  const [list, setList] = useState([]);

  const [hideDeactivated, setHideDeactivated] = useState<boolean>(false);

  const target = useRef();
  const [visiable, setVisiable] = useState<boolean>(false);
  const [modalProps, setModalProps] = useState<any>({});

  const { loading: getPickupLocationsLoading, run: _getPickupLocations } =
    useRequest(getPickupLocations, {
      manual: true,
      onSuccess(result) {
        setList(result);
      },
    });

  const {
    loading: setPickupLocationActivateLoading,
    run: _setPickupLocationActivate,
  } = useRequest((uuid) => setPickupLocationActivate(uuid), {
    manual: true,
    onSuccess(result) {
      _getPickupLocations();
      setVisiable(false);
    },
  });

  const {
    loading: setPickupLocationDeactivateLoading,
    run: _setPickupLocationDeactivate,
  } = useRequest((uuid) => setPickupLocationDeactivate(uuid), {
    manual: true,
    onSuccess(result) {
      _getPickupLocations();
      setVisiable(false);
    },
  });

  const toSetting = (uuid?: string) => {
    history.push(
      `/settings/logistics/pickuplocation/setting/${uuid ? uuid : ''}`,
    );
  };

  const onItemClick = (current) => {
    target.current = current;

    if (current.active) {
      setModalProps({
        title: getI18n('storeLogistics.warehouseLocations.deactivateLocation'),
        okButtonProps: {
          type: 'danger',
        },
        content: getI18n(
          'storeLogistics.warehouseLocations.deactivateLocationContent',
        ),
        okText: getI18n('storeLogistics.warehouseLocations.deactivate'),
      });
    } else {
      setModalProps({
        title: getI18n('storeLogistics.warehouseLocations.activateLocation'),
        okButtonProps: {
          type: 'primary',
        },
        content: getI18n(
          'storeLogistics.warehouseLocations.activateLocationContent',
        ),
        okText: getI18n('storeLogistics.warehouseLocations.activate'),
      });
    }

    setVisiable(true);
  };

  const showHideDeactivatedHandler = () => {
    setHideDeactivated(!hideDeactivated);
  };

  const onModalConfirm = () => {
    const current = target.current || null;
    if (current?.active) {
      _setPickupLocationDeactivate(current?.uuid);
    } else {
      _setPickupLocationActivate(current?.uuid);
    }
  };

  const onModalCancel = () => {
    setVisiable(false);
  };

  useEffect(() => {
    _getPickupLocations();
  }, []);

  // 是否展示 table 右下角的 Hide Deactivated Locations
  const showHideDeactivated = useMemo(
    () => list.some((item) => !item.defaultLocation && !item.active),
    [list],
  );

  // 页面用到的list
  const _list = useMemo(() => {
    const flist = list.filter((item) => {
      if (hideDeactivated) {
        return item.active;
      } else {
        return true;
      }
    });
    if (flist.length > 1) {
      return flist.map((item, index) => ({
        ...item,
        // active: !item.active,
        // defaultLocation = true 的,不可拖拽
        dragable: item.active,
      }));
    } else {
      return flist;
    }
  }, [hideDeactivated, list]);
  const options = useSelector(getAreaCodes());

  // table 列数据
  const columns = [
    {
      title: getI18n('storeLogistics.warehouseLocations.locations'),
      key: 'title',
      default: true,
      minWidth: 800,
      childGenerate: (_, record) => {
        const areaCodeInText =
          get(
            options.find((i) => i.uuid === get(record, 'areaCodeInfo.uuid')),
            'areaCode',
          ) || '';
        return (
          <div
            className={`${record.active ? '' : styles.deactivateItem} ${
              styles.locationsWrap
            }`}>
            <div className={styles.locationsWrapTitle}>
              <span className={styles.locationName}>{record.locationName}</span>
              {record.defaultLocation && (
                <span className={styles.locationsDefault}>
                  {getI18n('storeLogistics.warehouseLocations.default')}
                </span>
              )}
            </div>
            <div>{`${record.addressLine} ${record.province?.name} ${record.country?.description}`}</div>
            <div>{`+${areaCodeInText} ${record.phone}`}</div>
          </div>
        );
      },
    },
    {
      title: getI18n(
        'general.advancedFilters.commonStoreProductsWithTable.actions',
      ),
      default: true,
      optional: true,
      align: 'center',
      width: 126,
      childGenerate: (_, record, index) => {
        return (
          <div className={styles.action}>
            {delete_click_and_collect_pickup_location ? (
              record.active ? (
                <span
                  className={
                    record.defaultLocation ? styles.unable : styles.danger
                  }
                  onClick={() =>
                    !record.defaultLocation && onItemClick(record)
                  }>
                  {getI18n('storeLogistics.warehouseLocations.deactivate')}
                </span>
              ) : (
                <span
                  className={styles.primary}
                  onClick={() => onItemClick(record)}>
                  {getI18n('storeLogistics.warehouseLocations.activate')}
                </span>
              )
            ) : null}

            {view_click_and_collect_pickup_location_details && (
              <span
                className={styles.primary}
                onClick={() => toSetting(record.uuid)}>
                {getI18n('general.edit')}
              </span>
            )}
          </div>
        );
      },
    },
  ];

  return (
    <div className={styles.warehouseLocationsContainer}>
      <Spin
        spinning={
          getPickupLocationsLoading ||
          setPickupLocationActivateLoading ||
          setPickupLocationDeactivateLoading
        }>
        {_list.length === 0 ? (
          <div className={styles.norConfig}>
            <div className={styles.title}>
              {getI18n('storeLogistics.pickupLocations.pickupLocationsTitle')}
            </div>
            <div className={styles.description}>
              {getI18n(
                'storeLogistics.pickupLocations.pickupLocationsDescription',
              )}
            </div>
          </div>
        ) : (
          <div className={styles.table}>
            <SizeFittingTable
              id='PickupLocations'
              rowKey='uuid'
              pagination={false}
              dataSource={_list}
              columns={columns}
              rowClassName={styles.row}
            />
          </div>
        )}
      </Spin>
      <div className={`${_list.length != 0 ? styles.showOrHideBtns : ''}`}>
        <Button
          type='primary'
          disabled={!add_edit_click_and_collect_pickup_location}
          className={styles.button}
          onClick={() => toSetting()}>
          {getI18n('storeLogistics.pickupLocations.addPickupLocation')}
        </Button>
        {showHideDeactivated && (
          <span
            onClick={showHideDeactivatedHandler}
            className={styles.showOrHideBtn}>
            {`${
              hideDeactivated
                ? getI18n('general.show')
                : getI18n('general.hide')
            }`}{' '}
            {getI18n('storeLogistics.warehouseLocations.deactivatedLocations')}
          </span>
        )}
      </div>
      <Modal
        className={styles.warehouseModal}
        width={600}
        visible={visiable}
        confirmLoading={
          setPickupLocationActivateLoading || setPickupLocationDeactivateLoading
        }
        {...modalProps}
        onCancel={onModalCancel}
        onOk={onModalConfirm}>
        {modalProps.content}
      </Modal>
    </div>
  );
};
export default PickupLocations;
